export const DashboardCard = {
  height: 224,
  width: 276,
};

export const NotificationCard = {
  width: 296,
  height: (DashboardCard.height + 32) * 2 + 68,
};
